import React from 'react';
import './DrawShape.scss';
import { connect } from 'react-redux';
import {
  toggleDrawShapePanel,
  updateYears
} from '../../reducers/mapview/actions';
import AnalyzeInstructions from '../AnalyzeInstructions/AnalyzeInstructions';
import ShapeControls from '../ShapeControls/ShapeControls';
import ReportControls from '../ReportControls/ReportControls';

const DrawShape = ({
  charts,
  histogramResults,
  showAnalysis,
  snapshot,
  userDrawnPolygon,
  precalculatedShape,
  toggleDrawShapePanelFunction,
  precalculatedCSVData,
  totalArea,
  updateYearsSelectedFunction,
  yearsSelected
}) => {
  return (
    <div className="draw-shape__container">
      {showAnalysis || precalculatedCSVData ? (
        <ShapeControls
          yearsSelected={yearsSelected}
          precalculatedShape={precalculatedShape}
          precalculatedCSVData={precalculatedCSVData}
          updateYearsSelected={updateYearsSelectedFunction}
          userDrawnPolygon={userDrawnPolygon}
          charts={charts}
          histogramResults={histogramResults}
          snapshot={snapshot}
          totalArea={totalArea}
        />
      ) : (
        <AnalyzeInstructions />
      )}
    </div>
  );
};

const mapStateToProps = ({
  mapview: {
    charts,
    expandDrawPanel,
    histogramResults,
    reportIsAvailable,
    showAnalysis,
    snapshot,
    totalArea,
    precalculatedShape,
    userDrawnPolygon,
    precalculatedCSVData,
    yearsSelected
  }
}) => ({
  charts,
  expandDrawPanel,
  precalculatedShape,
  histogramResults,
  reportIsAvailable,
  showAnalysis,
  snapshot,
  totalArea,
  precalculatedCSVData,
  userDrawnPolygon,
  yearsSelected
});

const mapDispatchToProps = dispatch => ({
  toggleDrawShapePanelFunction: bool => {
    dispatch(toggleDrawShapePanel(bool));
    
  },
  updateYearsSelectedFunction: years => {
    dispatch(updateYears(years));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawShape);
